import React, { Component } from 'react';
import { Link } from "react-router-dom";
import {
  Button,
  Card,
  CardHeader,
  CardBody,
  Col,
  Container,
  Row,
  Table } from 'reactstrap';
import Modal from 'react-modal';
import SlidingPane from 'react-sliding-pane';
import Switch from 'react-switch';

class CorpMerchantDetail extends Component {
  state = {
    isPaneOpen: false,
    checked: true
  }

  componentDidMount() {
    Modal.setAppElement(this.el);
  }

  handleCheck1 = (checked) => {
    this.setState({ checked });
  }

  PlansOfferedTray = () => {
    return (
      <SlidingPane
        isOpen={ this.state.isPaneOpen }
        closeIcon={<img src='/icons/arrow-left-grey.svg' alt='close' />}
        title='Plans Offered'
        width='460px'
        onRequestClose={ () => {this.setState({ isPaneOpen: false });} }>

          <Card className="dark-shadow">
            <CardHeader className="text-left">
              Plan Name
              <Switch
                onChange={this.handleCheck1}
                checked={this.state.checked}
                className="toggle-switch float-right"
                onColor="#00BC6D"
                offColor="#A5B0BB"
              />
            </CardHeader>
            <Table className="mb-0" size="sm" responsive striped borderless>
              <tbody>
                <tr>
                  <td className="pl-3">Payout</td>
                  <td className="pr-3 text-right">3%</td>
                </tr>
                <tr>
                  <td className="pl-3">Term Length</td>
                  <td className="pr-3 text-right">36 Months</td>
                </tr>
                <tr>
                  <td className="pl-3">Interest Rate</td>
                  <td className="pr-3 text-right">28.99%</td>
                </tr>
                <tr>
                  <td className="pl-3">Origination Fee</td>
                  <td className="pr-3 text-right">0%</td>
                </tr>
                <tr>
                  <td className="pl-3">Promo</td>
                  <td className="pr-3 text-right">6 months no interest</td>
                </tr>
              </tbody>
            </Table>
          </Card>

          <Card className="dark-shadow">
            <CardHeader className="text-left">
              Plan Name
              <Switch
                onChange={this.handleCheck1}
                checked={this.state.checked}
                className="toggle-switch float-right"
                onColor="#00BC6D"
                offColor="#A5B0BB"
              />
            </CardHeader>
            <Table className="mb-0" size="sm" responsive striped borderless>
              <tbody>
                <tr>
                  <td className="pl-3">Payout</td>
                  <td className="pr-3 text-right">3%</td>
                </tr>
                <tr>
                  <td className="pl-3">Term Length</td>
                  <td className="pr-3 text-right">36 Months</td>
                </tr>
                <tr>
                  <td className="pl-3">Interest Rate</td>
                  <td className="pr-3 text-right">28.99%</td>
                </tr>
                <tr>
                  <td className="pl-3">Origination Fee</td>
                  <td className="pr-3 text-right">0%</td>
                </tr>
                <tr>
                  <td className="pl-3">Promo</td>
                  <td className="pr-3 text-right">6 months no interest</td>
                </tr>
              </tbody>
            </Table>
          </Card>

          <Card className="dark-shadow">
            <CardHeader className="text-left">
              Plan Name
              <Switch
                onChange={this.handleCheck1}
                checked={this.state.checked}
                className="toggle-switch float-right"
                onColor="#00BC6D"
                offColor="#A5B0BB"
              />
            </CardHeader>
            <Table className="mb-0" size="sm" responsive striped borderless>
              <tbody>
                <tr>
                  <td className="pl-3">Payout</td>
                  <td className="pr-3 text-right">3%</td>
                </tr>
                <tr>
                  <td className="pl-3">Term Length</td>
                  <td className="pr-3 text-right">36 Months</td>
                </tr>
                <tr>
                  <td className="pl-3">Interest Rate</td>
                  <td className="pr-3 text-right">28.99%</td>
                </tr>
                <tr>
                  <td className="pl-3">Origination Fee</td>
                  <td className="pr-3 text-right">0%</td>
                </tr>
                <tr>
                  <td className="pl-3">Promo</td>
                  <td className="pr-3 text-right">6 months no interest</td>
                </tr>
              </tbody>
            </Table>
          </Card>

          <Card className="dark-shadow">
            <CardHeader className="text-left">
              Plan Name
              <Switch
                onChange={this.handleCheck1}
                checked={this.state.checked}
                className="toggle-switch float-right"
                onColor="#00BC6D"
                offColor="#A5B0BB"
              />
            </CardHeader>
            <Table className="mb-0" size="sm" responsive striped borderless>
              <tbody>
                <tr>
                  <td className="pl-3">Payout</td>
                  <td className="pr-3 text-right">3%</td>
                </tr>
                <tr>
                  <td className="pl-3">Term Length</td>
                  <td className="pr-3 text-right">36 Months</td>
                </tr>
                <tr>
                  <td className="pl-3">Interest Rate</td>
                  <td className="pr-3 text-right">28.99%</td>
                </tr>
                <tr>
                  <td className="pl-3">Origination Fee</td>
                  <td className="pr-3 text-right">0%</td>
                </tr>
                <tr>
                  <td className="pl-3">Promo</td>
                  <td className="pr-3 text-right">6 months no interest</td>
                </tr>
              </tbody>
            </Table>
          </Card>

      </SlidingPane>
    )
  }

  render() {
    return (
      <div className="page-dashboard" ref={ref => this.el = ref}>

        <Container fluid>

          <Row className="mb-3 align-items-center">
            <Col md={5} xl={6} className="text-center text-md-left">
              <h3 className="d-lg-flex mb-3 mb-md-0">American Dental – Hollywood</h3>
            </Col>
            <Col md={7} xl={6}>
              <Container className="p-0 d-md-none mobile-buttons" fluid>
                <Row noGutters>
                  <Col md="auto" className="pl-3 pr-3 mb-1">
                    <Button
                      onClick={() => this.setState({ isPaneOpen: true })}
                      id="RequestRefundBtn"
                      className="w-100"
                      color="primary">
                      Plans Offered
                    </Button>
                  </Col>
                  <Col md="auto" className="pl-3 pr-3 mb-1">
                    <Button
                      tag={Link}
                      to="/corp/applications"
                      className="w-100"
                      color="primary">
                      Applicants
                    </Button>
                  </Col>
                  <Col md="auto" className="pl-3 pr-3">
                    <Button
                      tag={Link}
                      to="/corp/merchant-refunds"
                      className="w-100"
                      color="primary">
                      Refunds
                    </Button>
                  </Col>
                </Row>
              </Container>
              <Container className="p-0 d-none d-md-block" fluid>
                <Row className="flex-md-row justify-content-end">
                  <Col xs="auto" className="pl-1 pr-0">
                    <Button
                      onClick={() => this.setState({ isPaneOpen: true })}
                      className="w-100"
                      color="primary"
                      size="sm">
                      Plans Offered
                    </Button>
                  </Col>
                  <Col xs="auto" className="pl-1 pr-0">
                    <Button
                      tag={Link}
                      to="/corp/applications"
                      className="w-100"
                      color="primary"
                      size="sm">
                      Applicants
                    </Button>
                  </Col>
                  <Col xs="auto" className="pl-1">
                    <Button
                      tag={Link}
                      to="/corp/merchant-refunds"
                      className="w-100"
                      color="primary"
                      size="sm">
                      Refunds
                    </Button>
                  </Col>
                </Row>
              </Container>
            </Col>
          </Row>

          <Row>
            <Col md={4}>

              <Card>
                <CardHeader>
                  Merchant Information
                  <Button
                    size="sm"
                    color="link"
                    className="btn-icon btn-edit"
                  >
                    <img src="/icons/edit.svg" alt="Edit" />
                  </Button>
                </CardHeader>
                <CardBody>
                  <h6 className="text-primary">Name &amp; Location</h6>
                  <p className="mb-0"><strong>American Dental – Hollywood</strong><br />
                  DBA Name<br />
                  15303 Ventura Blvd #850<br />
                  Sherman Oaks, CA 91403</p>
                </CardBody>
                <CardBody>
                  <h6 className="text-primary">Contact Information</h6>
                  <p className="mb-0"><strong>Jane Doe</strong><br />
                  <a href="/">janedoe@americandental.com</a><br />
                  (123) 456-7890</p>
                </CardBody>
              </Card>

            </Col>
            <Col md={8}>

              <Card>
                <CardHeader>
                  Merchant Users
                  <Button
                    size="sm"
                    color="link"
                    className="btn-icon btn-edit"
                  >
                    <img src="/icons/edit.svg" alt="Edit" />
                  </Button>
                </CardHeader>
                <Table className="mb-0" size="sm" responsive striped borderless hover>
                  <thead>
                    <tr>
                      <th>Name</th>
                      <th>Username</th>
                      <th>License</th>
                      <th>Status</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>Dylan Avery</td>
                      <td>dylan.avery</td>
                      <td>39473027</td>
                      <td>Active</td>
                    </tr>
                    <tr>
                      <td>Dylan Avery</td>
                      <td>dylan.avery</td>
                      <td>39473027</td>
                      <td>Active</td>
                    </tr>
                    <tr>
                      <td>Dylan Avery</td>
                      <td>dylan.avery</td>
                      <td>39473027</td>
                      <td>Active</td>
                    </tr>
                    <tr>
                      <td>Dylan Avery</td>
                      <td>dylan.avery</td>
                      <td>39473027</td>
                      <td>Active</td>
                    </tr>
                  </tbody>
                </Table>
              </Card>

            </Col>
          </Row>

        </Container>

        <this.PlansOfferedTray />

      </div>
    );
  }
}

export default CorpMerchantDetail;
